import axios from "axios"
import JSZip from "jszip"
import FileSaver from "file-saver" 
export const downloadZip = {
  handleBatchDownload(data) {
    const zip = new JSZip()
    const cache = {}
    const promises = []
    let _this = this
    data.forEach((item) => {
      const promise = _this.getFile2(item.url).then((data) => {
        console.log("文件已下载",data);
        // 下载文件, 并存成ArrayBuffer对象
        zip.file(item.file_name, data, {
          binary: true,
        }) // 逐个添加文件
        cache[item.file_name] = data
      })
      promises.push(promise)
    })
    Promise.all(promises).then(() => {
      zip
        .generateAsync({
          type: "blob",
        })
        .then((content) => {
          // 生成二进制流
          FileSaver.saveAs(content, "批量下载.zip") // 利用file-saver保存文件
        })
    })
  },
  getFile2(url) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get", //使用get请求
        url, //放入的文件地址
        responseType: "arraybuffer", //请求的数据buffer对象
      })
        .then((data) => {
          resolve(data.data)
        })
        .catch((error) => {
          reject(error.toString())
        })
    })
  },
}